import { Dialog, DialogContent, DialogTitle } from '@dls/react-core';
import React from 'react';
import { ColorDLS } from '../../styling/color';
import { createUser, CreateUserDetails, User } from '../../api/studykit';
import { useSnackbar } from 'notistack';
import { NotiStackAction } from '../styled/notistack-action';
import { StyledBlueHeading } from '../styled/styles';
import { AsyncSubmitHandler } from '../../helpers/form-error-handling';
import { CreateUserForm } from '../users/create-user-form';
import { ConflictError } from '../../api/axios';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  studyId: string;
  onUserCreated: (data: User) => Promise<void>;
}

export const AddUserDialog: React.FC<DialogProps> = ({ open, onClose, studyId, onUserCreated }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const onSubmit: AsyncSubmitHandler<CreateUserDetails> = async (data, event) => {
    await createUser(studyId!, data)
      .then(onUserCreated)
      .then(() => {
        enqueueSnackbar(`${data.email} has successfully been added!`, {
          variant: 'success',
          action: <NotiStackAction close={closeSnackbar} />,
        });
        onClose();
      })
      .catch((err: Error) => {
        let msg = err.message;
        if (err instanceof ConflictError) {
          msg = `Unable to create user for ${data.email}. Please contact an administrator for help.`;
        }
        enqueueSnackbar(msg, {
          variant: 'error',
          action: <NotiStackAction close={closeSnackbar} />,
        });
      });
    event?.preventDefault();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <StyledBlueHeading variant="h2" style={{ color: ColorDLS.Blue45, fontWeight: 400 }}>
          User details
        </StyledBlueHeading>
      </DialogTitle>
      <DialogContent>
        <CreateUserForm onSubmit={onSubmit} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  );
};
